"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var INBOUNDDB_QUOTE_AUTOMATION_URL = 'inbounddbquotes/v1/workflows/approval';

var QuotesAPI =
/*#__PURE__*/
function () {
  function QuotesAPI() {
    (0, _classCallCheck2.default)(this, QuotesAPI);
  }

  (0, _createClass2.default)(QuotesAPI, null, [{
    key: "fetchWorkflows",
    value: function fetchWorkflows() {
      return _apiClient.default.get(INBOUNDDB_QUOTE_AUTOMATION_URL);
    }
  }, {
    key: "deleteWorkflow",
    value: function deleteWorkflow() {
      return _apiClient.default.delete(INBOUNDDB_QUOTE_AUTOMATION_URL);
    }
  }, {
    key: "createWorkflows",
    value: function createWorkflows(approverOwnerId) {
      return _apiClient.default.post(INBOUNDDB_QUOTE_AUTOMATION_URL, {
        data: {
          approverOwnerId: approverOwnerId
        }
      });
    }
  }]);
  return QuotesAPI;
}();

exports.default = QuotesAPI;
module.exports = exports.default;